import {
  OPTIMISER_DRIVER_GET,
  GET_DRIVER_WARRNING,
  GET_DRIVER_WARRNING_MORE,
  GET_DRIVERS_POLARIS,
  GET_DRIVERS_POLARIS_LIST_MORE,
  PAGE_CHANGED_DRIVERS,
  PAGE_LIMIT_CHANGED_DRIVERS,
  SEARCH_CHANGED_DRIVERS,
  ADD_DRIVER_POLARIS,
  UPDATE_DRIVER_POLARIS,
  REMOVE_ERROR_DRIVERS,
  RESET_SUCCESS_ACTION_DRIVERS,
  RESET_CONFIG_DRIVERS,
} from './actionsConsts'

export const fetchDriversOptimiser = (filter) => ({
  type: OPTIMISER_DRIVER_GET,
  payload: filter,
})

export const fetchDriversWarrning = (filter) => ({
  type: GET_DRIVER_WARRNING,
  payload: filter,
})

export const fetchDriversWarrningMoreScroll = (filter) => ({
  type: GET_DRIVER_WARRNING_MORE,
  payload: filter,
})

export const fetchDrivers = () => ({
  type: GET_DRIVERS_POLARIS,
})

export const getDriversMore = () => ({
  type: GET_DRIVERS_POLARIS_LIST_MORE,
})

export const pageChangedDrivers = (offset) => ({
  type: PAGE_CHANGED_DRIVERS,
  payload: { offset },
})

export const pageLimitChangedDrivers = (limit) => ({
  type: PAGE_LIMIT_CHANGED_DRIVERS,
  payload: { limit },
})

export const onAjoutSearchDriver = (search) => ({
  type: SEARCH_CHANGED_DRIVERS,
  payload: { search },
})

export const createDriver = (driver) => ({
  type: ADD_DRIVER_POLARIS,
  payload: { driver },
})

export const updateDriver = (payload, id) => ({
  type: UPDATE_DRIVER_POLARIS,
  payload: { newDriver: payload, id },
})

export const removeErrorDriver = () => ({
  type: REMOVE_ERROR_DRIVERS,
})

export const resetSuccessActionDrivers = () => ({
  type: RESET_SUCCESS_ACTION_DRIVERS,
})

export const resetDriversConfig = () => ({
  type: RESET_CONFIG_DRIVERS,
})
